<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';

export const Header2Registration: BuilderComponent = {
  name: 'Header2',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Header 2 text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    headerTag?: TypographyTags;
  }>(),
  {
    headerTag: 'h2',
  },
);
</script>

<template>
  <component :is="headerTag" class="font-semibold header-2 font-gelica">
    <slot />
  </component>
</template>

<style scoped>
.header-2 {
  @apply mb-0;
  font-size: 28px;
  line-height: 32px;
}
@media (min-width: 1024px) {
  .header-2 {
    font-size: 40px;
    line-height: 44px;
  }
}
</style>
